<template>
    <div>
        <div class="mt-3">
            <div class="text-secondary">
                <button
                    class="px-2 focus:outline-none border-r border-secondary"
                    :class="{
                        'text-darkGrayishBlue': przHistWithinDays === 30
                    }"
                    @click="przHistWithinDays = 30"
                >
                    {{ '最近一個月' }}
                </button>
                <button
                    class="px-2 focus:outline-none "
                    :class="{
                        'text-darkGrayishBlue': przHistWithinDays === undefined
                    }"
                    @click="przHistWithinDays = undefined"
                >
                    {{ '全部紀錄' }}
                </button>
            </div>
        </div>

        <div class="my-8 flex justify-center" v-if="loading">
            <spinner />
        </div>

        <div v-else-if="hasPrizeHistory" class="content-box-wrapper">
            <div class="text-xl font-bold">
                {{ '抽獎紀錄' }}
            </div>

            <div class="w-full flex flex-col">
                <div
                    v-for="(p, pi) in recordsInPage"
                    :key="pi"
                    class="w-full py-8 border-b border-dotted border-gray-100 flex flex-col sm:flex-row sm:items-center"
                >
                    <div class="w-full sm:w-1/2 md:w-2/5 flex-shrink-0">
                        <div class="my-1">
                            {{ '活動' }}
                            :
                            {{ p.prmtEvntName }}
                        </div>
                        <div class="my-1">
                            {{ '日期' }}
                            :
                            {{ p.custPrzCreDate | formatDate('fullDateTime') }}
                        </div>
                        <div class="my-1">
                            {{ '獎品' }}
                            :
                            {{ p.prmtEvntPrzName }}
                        </div>
                        <div class="my-1">
                            {{ '數量' }}
                            :
                            {{ p.custPrzQty }}
                        </div>
                    </div>
                    <div class="flex-grow flex flex-col items-stretch">
                        <div class="w-1/3 lg:w-1/4">
                            <productImage
                                imageType="small"
                                :product="p"
                                class="w-full"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-full flex justify-center mt-4">
                <pager
                    class="mx-auto"
                    :page="pager.page"
                    :recordsPerPage="pager.recordsPerPage"
                    :totalRecords="list.length"
                    @setPage="p => (pager.page = p)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import spinner from '../../components/spinner.vue';
import formatDate from '../../components/formatDateFilter';
import productImage from '../../components/productImage.vue';
import pager from '../../components/pager.vue';

export default {
    components: { spinner, productImage, pager },
    filters: { formatDate },
    data() {
        return {
            loading: true,
            pager: {
                page: 1,
                recordsPerPage: 10
            },
            prmtEvntId: this.$route.params.eventId,
            przHistWithinDays: 30
        };
    },
    async mounted() {
        this.loading = true;
        await this.$store.dispatch(
            'loadCustPrzHistList',
            this.przHistWithinDays
        );
        this.loading = false;

        this.$watch('przHistWithinDays', async function() {
            this.loading = true;
            await this.$store.dispatch(
                'loadCustPrzHistList',
                this.przHistWithinDays
            );
            this.loading = false;
        });
    },
    computed: {
        list() {
            return this.$store.getters.getCustPrzHistListByPrmtEvntId(
                this.prmtEvntId
            );
        },
        recordsInPage() {
            const start = (this.pager.page - 1) * this.pager.recordsPerPage;
            return this.list.slice(start, start + this.pager.recordsPerPage);
        },
        hasPrizeHistory() {
            return this.list && this.list.length;
        }
    }
};
</script>
